import { FormFieldsConfig } from "pages/components/Form/FormEntities";

const ResetPasswordFormConfig: FormFieldsConfig = {
  password: {
    constraints: [
      {
        message: "at_least_12_chars",
        validation: (val: string, values: any) => val.length > 8,
      },
      {
        message: "at_least_1_upper",
        validation: (val: string, values: any) => /[A-Z]/.test(val),
      },
      {
        message: "at_least_1_lower",
        validation: (val: string, values: any) => /[a-z]/.test(val),
      },
      {
        message: "at_least_1_number",
        validation: (val: string, values: any) => /\d/.test(val),
      },
      {
        message: "at_least_1_special",
        validation: (val: string, values: any) => /[\W_]+/.test(val),
      },
    ],
  },
  passwordConfirmation: {
    constraints: [
      {
        message: "password_confirmation",
        validation: (val: string, values: any) => val === values.password,
      },
    ],
  },
};

export default ResetPasswordFormConfig;
